import clsx from 'clsx';
import React from 'react';

import NewsletterSignUp from '../NewsletterSignup';
import styles from './headerStyle';

const Header = ({ currentUser, gdprColorScheme, gdpr, isSubscribed, newsletter, newsletterId }) => {
  return (
    <div className={styles.mainContainer} id="feed-newsletter-container-header">
      <div className={clsx(styles.headerContainer, 'container')}>
        <div className={styles.headerWrapper}>
          <div className={styles.newsletterIntro}>
            <div className={styles.title}>Newsletter</div>
            <h1 className={styles.newsletterName}>{newsletter.name}</h1>
            <div className={styles.newsletterAuthor}>by {newsletter.author.name}</div>
            <div className={styles.newsletterLandingPageDescription}>
              {newsletter.landingPageDescription}
            </div>
          </div>
          <div className={styles.newsletterAction}>
            <NewsletterSignUp
              newsletterId={newsletterId}
              isSubscribed={isSubscribed}
              currentUser={currentUser}
              newsletterName={newsletter.name}
              gdpr={gdpr}
              gdprColorScheme={gdprColorScheme}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
